import { SVGProps } from "react";

export function CrossIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {... props}
    >
      <line x1="10.5957" y1="0.353553" x2="1.06386" y2="9.88543" stroke="#7A7A7A" />
      <line x1="9.88473" y1="9.8848" x2="0.352846" y2="0.352923" stroke="#7A7A7A" />
    </svg>
  );
}
